import type { ChildProcess } from 'node:child_process';
import {
  killChildProcessTree,
  killChildProcessTreeGracefully,
} from '../../agents/acp/clients/kill-process-tree.js';
import type { LogFn } from '../../log.js';

/**
 * Send SIGTERM to the preview process tree and wait up to `graceMs` for `exit`.
 * Does not SIGKILL (caller checks still alive).
 */
export async function sigtermAndWaitForExit(
  proc: ChildProcess,
  graceMs: number,
  log: LogFn,
  shortId: string,
): Promise<void> {
  log(`[preview-environment] Sending SIGTERM to ${shortId} process tree (pid=${proc.pid ?? '?'}).`);
  await killChildProcessTreeGracefully(proc, graceMs);
}

/**
 * Remove listeners and SIGKILL the preview process tree (bridge shutdown timeout path).
 */
export function forceKillChild(proc: ChildProcess, log: LogFn, shortId: string, graceMs: number): void {
  log(
    `[preview-environment] ${shortId} did not exit within ${graceMs}ms; sending SIGKILL to process tree (pid=${proc.pid ?? '?'}).`,
  );
  proc.removeAllListeners();
  killChildProcessTree(proc, 'SIGKILL');
}
